/**
 * Network Functions
 * A group of utilities to handle network requests from Apollo Client
 */

import client from "./client"

/**
 * A proxy for Apollo Client's `mutate` function.
 *
 * @param {import("apollo-client").MutationOptions<any, any>} options
 * @param {{
 *  label: string
 *  next: null|function
 *  error: null|function
 * }} support options label to provide error reference, `next` as callback on success
 * receives the response from the server, and `error` as callback on network error
 * @example
 * ```
 * network.mutate({
 *  mutation: UPDATE_ENTRY,
 *  variables: update,
 * },
 * {label: "SomeSource", next: networkSuccessFunction? })
 * ```
 */
function mutate(
  options,
  support = { label: "unlabeled", next: null, error: null }
) {
  // 🦄
  debugger
  client
    .mutate(options)
    .then(response => {
      console.log(`LOG: [${support.label}]`, { update: options.variables })
      console.log(`LOG: [${support.label}] server response`, response)
      if (typeof support.next === "function") support.next(response)
    })
    .catch(err => {
      console.warn(`LOG: [${support.label}] network mutation failed.`)
      debugger //_
      if (typeof support.error === "function") support.error()
      else throw Error(err)
    })
}

const network = {
  mutate,
}

export default network
